export default __webpack_public_path__ + "static/media/detail_mobile_15_7.8721538b.jpg";